import { MasonryGrid } from "../../../../components-new";
import { useStore } from "../../../../helpers";
import { RequestCard, RequestCardSkeleton } from "./request-card";
import { DeleteRequestType } from "./delete-request-type";
import { AddRequestType } from "./add-request-type";

function RequestTypeCard({ searchdata }) {
  const { serviceRequestsStore } = useStore();
  const { loading } = serviceRequestsStore;
  return (
    <>
      <div className="flex justify-center">

        <MasonryGrid
          data={searchdata}
          isLoading={loading}
          skeletonCount={8}
          renderItem={(type) => (
            <RequestCard key={type["item"]["id"]} request={type["item"]} />
          )}
          renderSkeleton={(key) => <RequestCardSkeleton key={key} />}
        />


      </div>

      <AddRequestType />
      <DeleteRequestType />
    </>
  );
}

export default RequestTypeCard;
